/**
 * 主界面「事件选项」竖向 Tab 与按钮；`eventCode` 对应 `EventID`，插入时由 `createEmptyEventByCode` 实例化。
 */
import EventID from '@/model/EventClass/EventID'

export type PicShowPresetKind = 'far' | 'background' | 'foreground' | 'portrait'

export type EventPaletteItem = {
  label: string
  hint?: string
  eventCode: number
  picShowPreset?: PicShowPresetKind
  action?: 'open-variable-batch'
  availability?: 'custom-ui-button-click'
}

export type EventPaletteCategory = {
  key: string
  title: string
  items: EventPaletteItem[]
}

export const EVENT_PALETTE: EventPaletteCategory[] = [
  {
    key: 'msg',
    title: '消息',
    items: [
      { label: '显示文本', eventCode: EventID.Text },
      { label: '文字选项', eventCode: EventID.TextDif },
      { label: '图片选项', eventCode: EventID.ButtonDif },
      { label: '消失对话框', eventCode: EventID.DisposeText },
      { label: '注释', eventCode: EventID.Comment },
      { label: '自动播放剧情', eventCode: EventID.AutoPlay },
    ],
  },
  {
    key: 'logic',
    title: '逻辑',
    items: [
      { label: '数值操作', eventCode: EventID.Var },
      { label: '二周目数值', eventCode: EventID.VarsEx },
      { label: '字符串', eventCode: EventID.String },
      { label: '变量操作', eventCode: EventID.Var, action: 'open-variable-batch' },
      { label: '条件分歧', eventCode: EventID.IF },
      { label: '循环', eventCode: EventID.Loop },
      { label: '中断循环', eventCode: EventID.LoopBreak },
      { label: '存读档', eventCode: EventID.ForcedSaveRead },
      { label: '跳转剧情', eventCode: EventID.JumpStory },
      { label: '呼叫子剧情', eventCode: EventID.CallSubStory },
      { label: '返回标题画面', eventCode: EventID.BackTitle },
      { label: '剧情锁', eventCode: EventID.StoryLock },
    ],
  },
  {
    key: 'ui',
    title: 'UI界面',
    items: [
      { label: '打开界面', eventCode: EventID.CallMenu },
      { label: '关闭界面', eventCode: EventID.ReturnGameUI, availability: 'custom-ui-button-click' },
    ],
  },
  {
    key: 'effect',
    title: '效果',
    items: [
      { label: '等待', eventCode: EventID.Wait },
      { label: '天气', eventCode: EventID.Weather },
      { label: '闪烁', eventCode: EventID.Flash },
      { label: '震动', eventCode: EventID.Shake },
    ],
  },
  {
    key: 'image',
    title: '图像',
    items: [
      { label: '显示远景图', eventCode: EventID.PicShow, picShowPreset: 'far' },
      { label: '显示背景图', eventCode: EventID.PicShow, picShowPreset: 'background' },
      { label: '显示前景图', eventCode: EventID.PicShow, picShowPreset: 'foreground' },
      { label: '显示立绘', eventCode: EventID.PicShow, picShowPreset: 'portrait' },
      { label: '图片消除', eventCode: EventID.DisposePic },
      { label: '图片移动', eventCode: EventID.MovePic },
      { label: '图片旋转', eventCode: EventID.RotatePic },
    ],
  },
  {
    key: 'av',
    title: '音视频',
    items: [
      { label: '播放背景音乐', eventCode: EventID.StartBGM },
      { label: '播放音效', eventCode: EventID.StartSE },
      { label: '播放循环音效', eventCode: EventID.StartBGS },
      { label: '播放语音', eventCode: EventID.StartVoice },
      { label: '淡出背景音乐', eventCode: EventID.FadeBGM },
      { label: '淡出音效', eventCode: EventID.StopSE },
      { label: '淡出循环音效', eventCode: EventID.FadeBGS },
      { label: '淡出语音', eventCode: EventID.StopVoice },
    ],
  },
]
